import { Toolbar, Typography, Box, Link, IconButton } from "@mui/material";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import SwitchAccessShortcutOutlinedIcon from "@mui/icons-material/SwitchAccessShortcutOutlined";
import ApiOutlinedIcon from "@mui/icons-material/ApiOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { logout } from "../../API/RecordingTableAPI";
import { API_BASE_PATH } from "../../Config/Config";
import { getBrandLogo } from "../../utils/userDetailsUtils";
import nogruntblacklogo from "../../Assets/nogruntblacklogo.svg";
import { BootstrapTooltip } from "../../components/common/common.Component";
import useBuildVersionQuery from "../../useQuery/useBuildVersionQuery";

const AppToolbar = (props) => {
  const userDetails = localStorage.getItem("userDetail");
  const user = userDetails ? JSON.parse(userDetails) : null;
  const navigate = useNavigate();
  const { data: buildVersionData } = useBuildVersionQuery({ enabled: !!userDetails });

  const handleLogout = async () => {
    const isSsoLogin = localStorage.getItem("isSsoLogin") === "true" || user?.isSsoLogin === true;

    if (isSsoLogin && user?.sessionId) {
      localStorage.removeItem("userDetail");
      localStorage.removeItem("payment_completed");
      localStorage.removeItem("colorcode");
      localStorage.removeItem("isSsoLogin");

      const logoutUrl = `${API_BASE_PATH}/KeyLogging/sso/logout?sessionId=${user.sessionId}&uname=${user.email}`;
      window.location.href = logoutUrl;
      return;
    }

    // Non-SSO logout flow
    try {
      await logout();
    } catch (_) {}
    localStorage.removeItem("userDetail");
    localStorage.removeItem("payment_completed");
    localStorage.removeItem("colorcode");
    localStorage.removeItem("isSsoLogin");
    window.location.href = "/LoginPage";
  };

  const logoToShow = getBrandLogo(nogruntblacklogo);

  return (
    <Toolbar
      sx={{
        padding: "0",
        backgroundColor: "#f5f7f9",
        "@media (min-width:600px)": { paddingLeft: 0, paddingRight: 0 },
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ backgroundColor: "#5A6B7D", height: 64, width: props.drawerWidth }}
        >
          <BootstrapTooltip
            title={
              buildVersionData?.build_version
                ? `Build ${buildVersionData.build_version}${
                    buildVersionData?.db_version ? ` · DB ${buildVersionData.db_version}` : ""
                  }`
                : ""
            }
          >
            <img src={logoToShow} alt="Logo" />
          </BootstrapTooltip>
        </Box>
        <Box
          flex={1}
          height={64}
          color="#000"
          display="flex"
          alignItems="center"
          pl={3}
          pr={2}
          border="2px solid #e2e6f3"
        >
          {/* <Box flex={1}>
            <EditableText initialText="test" />
          </Box> */}
          <Box
            flex={1}
            columnGap={1}
            display="flex"
            flexDirection="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Link component={RouterLink} to="/new/help" underline="none">
              <Box
                color={"#000000"}
                display="flex"
                border="1px solid #000"
                p={1}
                borderRadius={2}
                sx={{ cursor: "pointer" }}
              >
                <HelpOutlineIcon />
                Help Center
              </Box>
            </Link>
            {/* <Link component={RouterLink} to="/dashboard/app" underline="none">
              <Box
                color={"#000000"}
                display="flex"
                border="1px solid #000"
                p={1}
                borderRadius={2}
                sx={{ cursor: "pointer" }}
              >
                <SwitchAccessShortcutOutlinedIcon />
                Switch to old
              </Box>
            </Link> */}

            <Typography color={"#444141"} fontSize="14px">
              {user?.products?.[0]?.firstname} {user?.products?.[0]?.lastname}
            </Typography>
            <IconButton onClick={() => handleLogout()}>
              <PowerSettingsNewIcon sx={{ color: "red" }} />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Toolbar>
  );
};

export default AppToolbar;
